export const root = {
  background: 'white',
  margin: '0px',
  boxSizing: 'border-box',

  '*, *::before, *::after': {
    boxSizing: 'inherit',
    margin: '0px',
    fontFamily: '"Lato", sans-serif',
  },
};
